import 'scss/solutions/authenticate.scss'
import 'babel-polyfill'
import {config} from 'config'
import 'js/libs/utils-solutions'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'

$(function () {
  $('.to-service-open').click(() => {
    $('html,body').animate({
      scrollTop: $('.auth-download').offset().top - 100
    }, 1e3)
  })
})
// initServiceOpen({
//   enableOpen: false,
//   modalTitle: '下载身份验证方案SDK',
//   noAppTip: '您还未创建应用，请先创建应用后使用该方案。',
//   allOpenedTip: '您的应用都已使用该方案，是否创建新应用？',
//   alertTip: '请选择要使用方案的应用',
//   unOpenTitle: '未使用该方案的应用',
//   openedTitle: '已使用该方案的应用',
//   okButton: '下载SDK'
// }, {
//   detailUrl: `${config.API}product/sdkDown`,
//   getAppUrl: `${config.API}sceneScheme/authenticate/get_app_list_by_service`
// })
// $(function () {
//   $('.to-service-open').click(function () {
//     showserviceOpenModal({}, {
//       sdkDownload: true,
//       ajaxParams: [{
//         'name': '身份验证识别',
//         'id': 'authenticate',
//         'type': null,
//         'featureType': null
//       }]
//     })
//   })
// })



// WEBPACK FOOTER //
// ./src/js/entry/solutions/authenticate.js